export default __webpack_public_path__ + "static/media/lasers-logo.dfe8f3ab.png";